import { Button } from '@/components/ui/button'
import { Select } from 'antd'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { FilterDescriptor } from 'store/grid'
import { isEmpty, isNotEmpty } from 'utils/is-empty'

export type SelectWalletModalOpenEvent = { filterId?: string; value: boolean }

interface SelectWalletFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onWalletModalOpen?: (event: SelectWalletModalOpenEvent) => void
}

export const SelectWalletFilter: React.FC<SelectWalletFilterProps> = (props) => {
  const { filter, onFilterChange, onWalletModalOpen } = props
  const walletsSelected = filter?.value ?? []
  const selectValues = filter?.value?.map((wallet: WalletDto) => wallet.id) ?? []

  if (isEmpty(selectValues) && onWalletModalOpen) {
    return (
      <Button
        variant='outline'
        size='sm'
        onClick={() => onWalletModalOpen({ filterId: filter.id, value: true })}
      >
        Choose Wallets
      </Button>
    )
  }

  return (
    <Select
      placeholder='Wallets'
      mode='multiple'
      value={selectValues}
      open={false}
      onFocus={() => {
        if (onWalletModalOpen) {
          onWalletModalOpen({ filterId: filter.id, value: true })
        }
      }}
      onChange={(values: string[]) => {
        const walletsState = isNotEmpty(values)
          ? walletsSelected.filter((x: WalletDto) => values.includes(x.id))
          : []

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, value: walletsState },
        })
      }}
      style={{ width: '250px' }}
    >
      {walletsSelected.map((wallet: WalletDto) => (
        <Select.Option value={wallet.id} key={wallet.id}>
          {wallet.name}
        </Select.Option>
      ))}
    </Select>
  )
}
